<template>
  <lego-modal-extend-v-2
    ref="modal"
    class="addWidgetPopup"
    :title="getPageTitle"
    :width="1600"
    @beforeClose="pageOnClosed"
  >
    <div class="table-widget-wrapper">
      <div v-if="isAddMode" class="td-col" style="max-width: 268px">
        <c-scroll :classStyle="'scroll_widget'" style="text-align: left">
          <c-label
            style="font-size: 16px; line-height: 16px"
            :color="$theme.COLOR.UI.UI13"
            :weight="500"
            >{{ $t('title.basicWidget') }}
          </c-label>
          <c-navi
            menuType="calculator"
            style="padding-right: 0px"
            v-model="defaultWidgetModel"
            @itemClick="onItemClick"
            :activeItemId="activeItemId"
            :lnbClosed="false"
          />
          <c-label
            style="margin-top: 40px; font-size: 16px; line-height: 16px"
            :color="$theme.COLOR.UI.UI13"
            :weight="500"
            >{{ $t('title.customWidget') }}
          </c-label>
          <c-navi
            menuType="calculator"
            style="padding-right: 0px"
            v-model="customWidgetModel"
            @itemClick="onItemClick"
            :activeItemId="activeItemId"
            :lnbClosed="false"
          />
        </c-scroll>
      </div>
      <div class="widget-setting" :class="{ 'widget-setting--add': isAddMode }">
        <component
          ref="config"
          :is="widgetConfigName"
          :configItems="configItems"
          @configModify="onConfigModify"
          :chartType="getChartType()"
          :searchDate="searchDate"
          :key="widgetConfigName"
          @changeValidate="changeStatusBtnConfirm"
          @update:changeField="(value) => (changedFieldData = value)"
        />
      </div>
      <div class="widget-preview px-16" :class="{ 'widget-preview--add': isAddMode }">
        <PreviewWidget
          ref="previewWidget"
          v-if="isPreviewWidget && this.configItems.length > 0"
          :widgetName="widgetName"
          :configItems="configItems"
          :searchDate="searchDate"
          @configModify="onConfigModify"
        />
      </div>
    </div>

    <template #footer>
      <lego-button @click="pageOnClosed">{{ $t('button.cancel') }}</lego-button>
      <lego-button
        @click="doAction('WIDGET_SAVE')"
        :disabled="disabled || isDisabledConfirm || !changedFieldData"
        main
      >
        {{ $t('button.save') }}
      </lego-button>
    </template>
  </lego-modal-extend-v-2>
</template>
<script>
import TitleBoxWidgetConfig from './configs/TitleBoxWidgetConfig';
import EventStausWidgetConfig from './configs/EventStausWidgetConfig';
import MonitoringStatusWidgetConfig from './configs/MonitoringStatusWidgetConfig';
import PerfermanceTop5WidgetConfig from './configs/PerfermanceTop5WidgetConfig';
import EventMapWidgetConfig from './configs/EventMapWidgetConfig';
import EventHistoryWidgetConfig from './configs/EventHistoryWidgetConfig';
import TimeSeriesGraphWidgetConfig from './configs/TimeSeriesGraphWidgetConfig';
import StatusMetricWidgetConfig from './configs/StatusMetricWidgetConfig';
import InstanceMapWidgetConfig from './configs/InstanceMapWidgetConfig';
import PreviewWidget from '@/containers/widget/PreviewWidget.vue';
import LegoModalExtendV2 from '@/components/lego/extend/legoModalExtendV2.vue';
import { mapActions } from 'vuex';
import legoEventBus from '@/lego-component/utils/eventBus/eventBus';

export default {
  name: 'AddWidgetPopup',
  emits: ['close', 'widgetCount', 'widgetAdd'],
  props: {
    // 등록 & 수정 flag
    mode: {
      type: String,
      default: 'add' //'add' //'externalAdd'
    },
    // 외부(성능비교)에서 위젯 추가시 위젯 설정 정보
    config: {
      type: Object
    },
    // dashboard 검색시간
    searchDate: {
      type: Object
    }
  },
  provide() {
    return {
      mode: this.mode
    };
  },
  components: {
    TitleBoxWidgetConfig,
    EventStausWidgetConfig,
    MonitoringStatusWidgetConfig,
    PerfermanceTop5WidgetConfig,
    EventMapWidgetConfig,
    EventHistoryWidgetConfig,
    TimeSeriesGraphWidgetConfig,
    StatusMetricWidgetConfig,
    InstanceMapWidgetConfig,
    PreviewWidget,
    LegoModalExtendV2
  },
  data() {
    return {
      // 기본 위젯 정보
      changedFieldData: false,
      defaultWidgetModel: [
        {
          id: 'TitleBoxWidget',
          name: this.$t('title.titleBox'),
          dirtyChk: 'G'
        },
        {
          id: 'EventStausWidget',
          name: this.$t('title.eventStatus'),
          dirtyChk: 'G'
        },
        {
          id: 'MonitoringStatusWidget',
          name: this.$t('title.monitoringStatus'),
          dirtyChk: 'G'
        },
        {
          id: 'PerfermanceTop5Widget',
          name: this.$t('title.mainPerformanceTop'),
          dirtyChk: 'P'
        },
        {
          id: 'EventMapWidget',
          name: this.$t('title.eventMap'),
          dirtyChk: 'G'
        },
        {
          id: 'EventHistoryWidget',
          name: this.$t('title.eventHistory'),
          dirtyChk: 'G'
        }
      ],
      // 커스텀 위젯 정보
      customWidgetModel: [
        {
          id: 'TimeSeriesGraphWidget',
          name: this.$t('title.timeSeriesGraph'),
          dirtyChk: 'P'
        },
        {
          id: 'StatusMetricWidget',
          name: this.$t('title.currentStatusIndex'),
          dirtyChk: 'P'
        },
        {
          id: 'InstanceMapWidget',
          name: this.$t('title.instanceMap'),
          dirtyChk: 'P'
        }
      ],
      widgetConfigName: '', // config 위젯 설정 컴퍼넌트명
      widgetName: '', // 위젯 설정 컴포넌트명
      activeItemId: '', // active 위젯 ID
      configItems: [], // 위젯 설정 정보
      tempItem: {}, // 이전 widget 정보
      isGetConfigModify: false, // 이전 widget 정보
      isDisabledConfirm: false, // 이전 widget 정보
      disabled: false // 등록버튼 활성화 여부,
    };
  },
  computed: {
    // 등록 flag 여부
    isAddMode() {
      //console.log('this.mode = ', this.mode);
      return this.mode == 'add';
    },
    // 모달 title
    getPageTitle: function () {
      let title = '';
      if (this.mode == 'add') {
        title = this.$t('page.dashboard.Addwidget');
      } else if (this.mode == 'externalAdd') {
        title = this.$t('title.timeSeriesGraph') + ' ' + this.$t('page.dashboard.Addwidget');
      } else {
        title = this.$t('label.editWidget');
      }
      return title;
    },
    isPreviewWidget() {
      if (this.mode == 'externalAdd' && !this.isGetConfigModify) {
        return false;
      }
      return true;
    }
  },
  created() {
    if (this.mode == 'externalAdd') {
      this.setExternalAdd(this.config);
    } else {
      this.setWidgetInfo(this.defaultWidgetModel[0]);
    }
  },
  mounted() {
    this.$refs['modal'].open();
  },
  methods: {
    ...mapActions('metric', ['resetSelectMetric']),
    // 위젯 설정 정보 저장
    pageOnClosed() {
      legoEventBus.$emit('click-outside');

      // eslint-disable-next-line no-debugger
      // const isChangedData = this.$refs.config.isChanged || this.$refs.previewWidget.isChanged;
      if (this.changedFieldData) {
        const message =
          `<div>` +
          this.$t('message.notNotifyWritingInfo') +
          `</br>` +
          this.$t('message.moveTheScreenNotify') +
          `</div>`;
        this.$alert(message, this.$t('page.dashboard.notice'), {
          cancel: () => {},
          action: () => {
            this.$emit('close');
          }
        });
      } else {
        this.$emit('close');
      }
    },
    doAction() {
      if (!this.$refs.config.validate()) {
        console.warn('validate error');
        return;
      }

      //console.log('★ doAction ', cmd, JSON.stringify(parms, null, '  '));
      //console.log('this.configItems = ', this.configItems);

      this.$emit('widgetCount', this.configItems.length);
      this.$emit('widgetAdd', this.configItems);

      this.configItems = [];
      this.$emit('close');
    },
    getChartType() {
      if (this.$refs.previewWidget) {
        return this.$refs.previewWidget.chartType;
      }
      return '';
    },
    /** 위젯 메뉴 Click
     * 기존 위젯의 설정 정보가 있으면 경고창 뛰우고 메뉴 이동
     * */
    onItemClick(item) {
      if (item.id == this.tempItem.id) return false;

      let isDirty = false;
      if (this.tempItem.dirtyChk == 'P') {
        isDirty = this.$refs.config.isDirtyCheck();
      }
      if (isDirty || this.changedFieldData) {
        window.app.$modal.open({
          rootId: 'app',
          type: 'confirm',
          title: this.$t('title.notice'),
          message: this.$t('page.widget.dirtyCheck'),
          action: () => {
            this.setWidgetInfo(item);
          }
        });
      } else {
        this.setWidgetInfo(item);
      }
    },

    /** 위젯 ID 셋팅 및 컴퍼넌트 설정 */
    setWidgetInfo(item) {
      this.resetSelectMetric();
      this.tempItem = item;
      this.configItems = [];
      this.activeItemId = item.id;
      this.widgetConfigName = item.id + 'Config';
      this.widgetName = item.id;
    },

    // 위젯 설정 정보 update Event;
    onConfigModify(param) {
      let chartAttr;
      const widgetType = ['TimeSeriesGraphWidget', 'StatusMetricWidget', 'InstanceMapWidget'];

      if (param.length > 0 && param[0].chartAttr) {
        chartAttr = param[0].chartAttr;
      }

      if (chartAttr && widgetType.includes(chartAttr.widget.type)) {
        if (
          !chartAttr.widget.options.resourceType ||
          !chartAttr.widget.options.metricKey ||
          !chartAttr.widget.options.products ||
          !chartAttr.widget.options.products.length ||
          (!chartAttr.widget.options.disableIndividualItem &&
            (chartAttr.widget.options.objects.length === 0 ||
              (chartAttr.widget.options.objects.length > 0 &&
                chartAttr.widget.type === 'StatusMetricWidget' &&
                !chartAttr.widget.options.targetsMethod)))
        ) {
          param = [];
        }
      }
      this.isGetConfigModify = true;
      this.configItems = param;
    },

    // 외부 위젯 추가시 설정정보 셋팅
    setExternalAdd(config) {
      this.orgConfig = config;
      let widgetType = config.chartAttr.widget.type;
      this.configItems.length = 0;
      this.configItems.push(config);
      this.widgetConfigName = widgetType + 'Config';
      this.widgetName = widgetType;
    },
    changeStatusBtnConfirm(value) {
      this.isDisabledConfirm = value;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scpm.scss';
@import './configs/styles/addWidgetPopup.scss';
</style>
